import { connect } from "react-redux";

import { getIsReconsentRequired, isLoggedIn } from "../../state/modules/user";
import {
  getCountryCode,
  getDefaultLanguage,
  getDefaultStoreUrl,
  getKeyStoreDataversion,
  getStoreCode
} from "../../state/modules/regionalStore";
import { getFeature } from "../../state/modules/features";

import MyAccountLinks from "./MyAccountLinks";

function mapStateToProps(state) {
  return {
    countryCode: getCountryCode(state),
    defaultStoreUrl: getDefaultStoreUrl(state),
    eventIconToggle: getFeature(state, "web-event-icon"),
    isLoggedIn: isLoggedIn(state),
    isReconsentRequired: getIsReconsentRequired(state),
    keyStoreDataversion: getKeyStoreDataversion(state),
    lang: getDefaultLanguage(state),
    storeCode: getStoreCode(state)
  };
}

export default connect(mapStateToProps)(MyAccountLinks);
